import { render, staticRenderFns } from "./fileElement.vue?vue&type=template&id=67a4b1a9&scoped=true"
import script from "./fileElement.vue?vue&type=script&lang=js"
export * from "./fileElement.vue?vue&type=script&lang=js"
import style0 from "./fileElement.vue?vue&type=style&index=0&id=67a4b1a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a4b1a9",
  null
  
)

export default component.exports